import React from 'react';

interface QuestionSkeletonProps {
  qType?: 'mcq' | 'cq';
  count?: number;
}

export default function QuestionSkeleton({ qType = 'mcq', count = 3 }: QuestionSkeletonProps) {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="bg-white/60 dark:bg-[#1E1E1E]/30 border border-white/20 dark:border-white/10 rounded-3xl p-6 shadow-[0_8px_32px_rgba(31,38,135,0.04)] dark:shadow-[0_8px_32px_rgba(0,0,0,0.15)] space-y-5 text-left"
        >
          {/* Header */}
          <div className="flex items-center gap-4">
            <div className="w-8 h-8 rounded-full skel-shimmer flex-shrink-0" />
            <div className="h-5 skel-shimmer rounded-lg w-1/3" />
          </div>

          {/* Body / Stem */}
          {qType === 'cq' ? (
            <div className="space-y-2.5 p-5 rounded-2xl bg-gray-100/50 dark:bg-white/5 border-l-4 border-l-gray-200 dark:border-l-white/20">
              <div className="h-3.5 skel-shimmer rounded w-full" />
              <div className="h-3.5 skel-shimmer rounded w-11/12" />
              <div className="h-3.5 skel-shimmer rounded w-4/5" />
            </div>
          ) : (
            <div className="h-3.5 skel-shimmer rounded w-10/12 ml-12" />
          )}

          {/* Options / Sub-questions */}
          <div className={`space-y-3.5 ${qType === 'cq' ? 'pl-4 md:pl-12' : 'pl-0 md:pl-12'}`}>
            {Array.from({ length: 4 }).map((_, j) => (
              <div key={j} className="flex items-center gap-3">
                <div className="w-6 h-6 rounded-full skel-shimmer flex-shrink-0" />
                <div className="h-3.5 skel-shimmer rounded w-2/3" />
              </div>
            ))}
          </div>

          {/* Footer */}
          <div className="border-t border-gray-100 dark:border-white/5 pt-4 pl-0 md:pl-12 flex justify-between items-center">
            <div className="h-3.5 skel-shimmer rounded w-16" />
            <div className="flex gap-4">
              <div className="w-8 h-4 skel-shimmer rounded" />
              <div className="w-8 h-4 skel-shimmer rounded" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
